import React from 'react';
import {render} from 'react-dom';

var Fluxxor = require('fluxxor');
import { FluxMixin, StoreWatchMixin, flux} from '../../../flux';

import {Login} from './Login.jsx'; 
import {SignUp} from './SignUp.jsx';
import {wpImage} from '../../../wpImage';

var SignUpPopup = React.createClass({
	mixins: [wpImage, FluxMixin, StoreWatchMixin("MainStore")],
	getStateFromFlux: function(){
		var flux = this.getFlux();
		return{
				signInData: flux.store("MainStore").signInData,
                signInError: flux.store("MainStore").signInError,
                signUpData: flux.store("MainStore").signUpData,
                signUpError: flux.store("MainStore").signUpError,
                signUpPopup: flux.store("MainStore").signUpPopup
		}
	},
	loginClick: function(userName, password){
		this.getFlux().actions.loginClick(userName, password, this.state.signUpPopup.action, this.state.signUpPopup.slug);		
	},
	signUp: function(flag, name, userName, password, email){
		this.getFlux().actions.signUp(flag, name, userName, password, email,  this.state.signUpPopup.action, this.state.signUpPopup.slug);
	},
	clearLoginErrors: function(){
		this.getFlux().actions.clearLoginErrors();
	},
	handleCloseClick: function(){
		this.getFlux().actions.signUp(false);
	},
	forgotPassword: function(){
		this.getFlux().actions.resetPassword("open", this.state.signUpPopup);
	},
	stopPropagation: function(e){
		e.stopPropagation();
	},	
  	render: function(){
	    return(
			<div className="modal__mask" onClick = {this.handleCloseClick}> 
				<div className="modal__content modal--lg" onClick = {this.stopPropagation}>
				  <div className="modal__body clearfix"> 
				  	<a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}>
				  		<i className="fa  fa-close"> </i>
				  	</a> 
				   	<Login 	loginClick = {this.loginClick} 
			      		 	signInError = {this.state.signInError}
			      		 	clearLoginErrors = {this.clearLoginErrors}
			      		 	forgotPassword = {this.forgotPassword}
			      		 	signInData = {this.state.signInData}
			      		 	signUpPopup = {this.state.signUpPopup} />
			      	<SignUp signUp = {this.signUp}
			      			signUpError = {this.state.signUpError}
			      			clearLoginErrors = {this.clearLoginErrors} />   
				  </div>
				</div>
			</div>
	    );
  	}
});

export {SignUpPopup}


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SignUpPopup/index.jsx
 **/